module.exports = __webpack_public_path__ + "img/tintuc15.d8cb7e53.png";